import { ENDPOINTS } from "@/constants/api/endpoints";
import { useApiQuery } from "../../hooks/use-api-query";
import { queryKeys } from "../../query-keys";
import { StoryItemResponse } from "@/types/story";

export const useStoryItems = (storyGroupId: string | null) => {
  return useApiQuery<StoryItemResponse>(
    queryKeys.stories.items(storyGroupId),
    `${ENDPOINTS.CONTENTS.STORIES}/${storyGroupId}`,
    {},
    {
      enabled: !!storyGroupId,
      staleTime: 5 * 60 * 1000,
    }
  );
};
